module.exports = __webpack_public_path__ + "img/29.0221f09.jpg";